// extracted by mini-css-extract-plugin
module.exports = {"dropdown__item":"styles__dropdown__item___2gORZ","dropdown__icon":"styles__dropdown__icon___2Z1zH","dropdown__text":"styles__dropdown__text___3ax0P"};